import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { toast } from "react-toastify";
import { useUser } from "../context/UserProvider";
import { request } from "../utill";
import LoadingSpinner from "../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { userData } = useUser();
  const { saveUserData, clearUserData } = useUser();
  const navigate = useNavigate()

  const [licensePlateNumber, setLicensePlateNumber] = useState(
    userData?.license_plate_number || ""
  );
  const [chassisNumber, setChassisNumber] = useState(
    userData?.chassis_number || ""
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLicensePlateChange = (e) => setLicensePlateNumber(e.target.value);
  const handleChassisNumberChange = (e) => setChassisNumber(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      setLoading(true);
      const response = await request("/esalat-user/update-profile", "POST", {
        license_plate_number: licensePlateNumber,
        chassis_number: chassisNumber,
      });

      if (response.success) {
        clearUserData()
        toast.success("اطلاعات با موفقیت ذخیره شد.");
        saveUserData(response.user);
        navigate("/orders")
      } else {
        toast.error(response.message || "خطا در ذخیره اطلاعات.");
      }
    } catch (error) {
      toast.error("مشکلی پیش آمد. لطفاً دوباره تلاش کنید.");
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  useEffect(()=>{
    setLicensePlateNumber(userData?.license_plate_number)
    setChassisNumber(userData?.chassis_number)
  }, [userData])

  return (
    <Layout>
        {loading && <LoadingSpinner />}
      <h1 className="profile-title">ویرایش پروفایل</h1>
      <form onSubmit={handleSubmit} className="mt-5">
        <div className="AZ-field-group">
          <label htmlFor="licensePlate">شماره پلاک</label>
          <input
            type="text"
            id="licensePlate"
            className="form-control"
            value={licensePlateNumber}
            onChange={handleLicensePlateChange}
          />
        </div>

        <div className="AZ-field-group">
          <label htmlFor="chassisNumber">شماره شاسی</label>
          <input
            type="text"
            id="chassisNumber"
            className="form-control"
            value={chassisNumber}
            onChange={handleChassisNumberChange}
          />
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="AZ-primary-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? "در حال ذخیره..." : "ذخیره"}
          </button>
        </div>
      </form>
    </Layout>
  );
}
